export default __webpack_public_path__ + "static/media/sofort.2c14e989.svg";